(function () {

  var DISPATCH_TABLE = { 0:3, 1:2, 2:2, 3:5, 4:4, 5:4, 6:3 };
  var DISPATCH_DAYS  = [1, 2, 3, 4];
  var WEEKS_AHEAD    = 6;
  var MONTHS = [
    'January','February','March','April','May','June',
    'July','August','September','October','November','December'
  ];

  var s = {
    yr: 0, mo: 0,
    sel: '',
    minStr: '',
    maxStr: '',
    disabled: []
  };
window.__ddcSel = s;
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function toStr(d) {
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }

  function toFmt(v) {
    return new Date(v + 'T00:00:00').toLocaleDateString('en-GB', {
      weekday: 'short', day: 'numeric', month: 'short', year: 'numeric'
    });
  }

  function getMinDate() {
    var t = new Date();
    t.setHours(0, 0, 0, 0);
    var m = new Date(t);
    m.setDate(t.getDate() + DISPATCH_TABLE[t.getDay()]);
    return m;
  }

  function getMaxDate() {
    var t = new Date();
    t.setHours(0, 0, 0, 0);
    var m = new Date(t);
    m.setDate(t.getDate() + (WEEKS_AHEAD * 7));
    return m;
  }

  function isOff(d)     { return DISPATCH_DAYS.indexOf(d.getDay()) === -1; }
  function isPast(v)    { return v < s.minStr; }
  function isFuture(v)  { return v > s.maxStr; }
  function isBlocked(v) { return s.disabled.indexOf(v) !== -1; }

  function note(msg, type) {
    var el = document.getElementById('ddc-note');
    if (!el) return;
    el.textContent = msg;
    el.className   = 'ddc-msg' + (type ? ' ' + type : '');
  }

  function openCal() {
    document.getElementById('ddc-popover').classList.add('open');
    document.getElementById('ddc-input').classList.add('open');
    document.getElementById('ddc-input').setAttribute('aria-expanded', 'true');
  }

  function closeCal() {
    document.getElementById('ddc-popover').classList.remove('open');
    document.getElementById('ddc-input').classList.remove('open');
    document.getElementById('ddc-input').setAttribute('aria-expanded', 'false');
    note('');
  }

  function saveCart(v) {
    var h = document.getElementById('ddc-value');
    if (h) h.value = v;
    fetch('/cart/update.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ attributes: { 'Requested Dispatch Date': v } })
    })
    .catch(function (e) { console.error('[DDC]', e); });
  }

  function updateNavButtons(minDate, maxDate) {
    var prevBtn = document.getElementById('ddc-prev');
    var nextBtn = document.getElementById('ddc-next');

    var atMin = (s.yr === minDate.getFullYear() && s.mo === minDate.getMonth());
    var atMax = (s.yr === maxDate.getFullYear() && s.mo === maxDate.getMonth());

    prevBtn.disabled = atMin;
    nextBtn.disabled = atMax;
  }

  function render() {
    var grid = document.getElementById('ddc-days');
    var lbl  = document.getElementById('ddc-month-label');
    if (!grid || !lbl) return;

    lbl.textContent = MONTHS[s.mo] + ' ' + s.yr;
    grid.innerHTML  = '';

    var today  = toStr(new Date());
    var first  = new Date(s.yr, s.mo, 1);
    var last   = new Date(s.yr, s.mo + 1, 0).getDate();
    var offset = (first.getDay() + 6) % 7;

    for (var i = 0; i < offset; i++) {
      var blank = document.createElement('div');
      blank.className = 'ddc-day ddc-empty';
      grid.appendChild(blank);
    }

    for (var d = 1; d <= last; d++) {
      var date = new Date(s.yr, s.mo, d);
      var v    = toStr(date);
      var btn  = document.createElement('button');
      btn.type        = 'button';
      btn.textContent = d;

      var cls    = ['ddc-day'];
      var reason = '';

      if (v === today) cls.push('ddc-today');
      if (v === s.sel) cls.push('ddc-sel');

      if (isPast(v)) {
        cls.push('ddc-unavail'); reason = 'past';
      } else if (isFuture(v)) {
        cls.push('ddc-unavail'); reason = 'future';
      } else if (isOff(date)) {
        cls.push('ddc-unavail'); reason = 'off';
      } else if (isBlocked(v)) {
        cls.push('ddc-blocked'); reason = 'blocked';
      }

      btn.className = cls.join(' ');

      (function (dateVal, dateReason) {
        btn.addEventListener('click', function () {
          if (dateReason === 'past') {
            note('Please select ' + toFmt(s.minStr) + ' or a later date.', 'err'); return;
          }
          if (dateReason === 'future') {
            note('Dates beyond 6 weeks are not yet available for booking.', 'err'); return;
          }
          if (dateReason === 'off') {
            note('No dispatch on this day. Please choose Mon – Thu.', 'err'); return;
          }
          if (dateReason === 'blocked') {
            note('This date is not available. Please choose another date.', 'err'); return;
          }

          s.sel = dateVal;
          render();
          saveCart(dateVal);

          var txt = document.getElementById('ddc-input-text');
          if (txt) { txt.textContent = toFmt(dateVal); txt.classList.remove('empty'); }

          note('');

          closeCal();
        });
      })(v, reason);

      grid.appendChild(btn);
    }
  }

  function init() {
    var w = document.getElementById('dispatch-date-wrapper');
    if (!w || w.dataset.init) return;
    w.dataset.init = '1';

    var saved = w.getAttribute('data-saved') || '';

    // Parse comma-separated blocked dates from Liquid
    var rawDis = w.getAttribute('data-disabled') || '';
    s.disabled = rawDis
      .split(',')
      .map(function(d) { return d.trim(); })
      .filter(Boolean);

    var min  = getMinDate();
    var max  = getMaxDate();
    s.minStr = toStr(min);
    s.maxStr = toStr(max);

    // Invalidate saved date if no longer valid
    if (saved && (isPast(saved) || isFuture(saved) || isOff(new Date(saved + 'T00:00:00')) || isBlocked(saved))) {
      saved = '';
    }

    // Don't auto-select — leave empty if no valid saved date
    s.sel = saved || '';

    if (saved) {
      var sd = new Date(s.sel + 'T00:00:00');
      s.yr = sd.getFullYear();
      s.mo = sd.getMonth();
    } else {
      // Open on min date's month but select nothing
      s.yr = min.getFullYear();
      s.mo = min.getMonth();
    }

    render();
    updateNavButtons(min, max);

    var txt = document.getElementById('ddc-input-text');

    if (saved) {
      txt.textContent = toFmt(s.sel);
      txt.classList.remove('empty');
    } else {
      txt.textContent = 'Select a date';
      txt.classList.add('empty');
    }

    // ── Toggle calendar open/close ───────────────────────────────────────
    document.getElementById('ddc-input').addEventListener('click', function () {
      document.getElementById('ddc-popover').classList.contains('open')
        ? closeCal() : openCal();
    });

    document.getElementById('ddc-input').addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        document.getElementById('ddc-popover').classList.contains('open')
          ? closeCal() : openCal();
      }
      if (e.key === 'Escape') closeCal();
    });

    document.addEventListener('click', function (e) {
      var wrapper = document.getElementById('dispatch-date-wrapper');
      if (wrapper && !wrapper.contains(e.target)) closeCal();
    });

    // ── Month navigation ─────────────────────────────────────────────────
    document.getElementById('ddc-prev').addEventListener('click', function (e) {
      e.stopPropagation();
      var minY = min.getFullYear(), minM = min.getMonth();
      s.mo--;
      if (s.mo < 0) { s.mo = 11; s.yr--; }
      if (s.yr < minY || (s.yr === minY && s.mo < minM)) {
        s.yr = minY; s.mo = minM;
      }
      render();
      updateNavButtons(min, max);
    });

    document.getElementById('ddc-next').addEventListener('click', function (e) {
      e.stopPropagation();
      var maxY = max.getFullYear(), maxM = max.getMonth();
      s.mo++;
      if (s.mo > 11) { s.mo = 0; s.yr++; }
      if (s.yr > maxY || (s.yr === maxY && s.mo > maxM)) {
        s.yr = maxY; s.mo = maxM;
      }
      render();
      updateNavButtons(min, max);
    });

    // ── Checkout validation ──────────────────────────────────────────────
    var checkoutBtn = document.getElementById('checkout');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function (e) {
        if (!s.sel) {
          e.preventDefault();
          note('Please select a dispatch date before continuing.', 'err');
        }
      }, true);
    }
    // ── / Checkout validation ────────────────────────────────────────────

  }

  new MutationObserver(function () {
    if (document.getElementById('dispatch-date-wrapper')) init();
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', init);

})();